import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-buy-quote-request-thanks',
  templateUrl: './buy-quote-request-thanks.component.html',
  styleUrls: ['./buy-quote-request-thanks.component.css']
})
export class BuyQuoteRequestThanksComponent implements OnInit {

    constructor(
        private router: Router
    ) { }

    title: string;
    description: string;
    errorDetail: string;

    ngOnInit(): void {
        let tender = JSON.parse(localStorage.getItem('TEMP_TENDER'));
        console.log(tender);
        localStorage.removeItem('TEMP_TENDER');
        const errorMsg = localStorage.getItem('ERROR_MSG');
        const errorMsgDet = localStorage.getItem('ERROR_MSG_DET');

        if (errorMsg) {
            this.title = 'CI DISPIACE';
            this.description = errorMsg;
            if (errorMsgDet) {
                this.errorDetail =  errorMsgDet;
            }
        } else {
            this.title = 'GRAZIE';
            this.description = 'Grazie per aver acquistato la Richiesta di preventivo. La troverai nella tua area riservata, dove potrai terminare l’inserimento delle informazioni e, successivamente, pubblicarla.';
            this.errorDetail = null;
        }

    }

    goToTenders() {
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'tenders' } });
        //window.open('/areariservata?tabToLoad=tenders','_self');
    }

}
